import { Zodios } from '@zodios/core';
// Use the API contract directly from the API source during local dev
// This avoids bundling/interop issues and is always available in this monorepo
import lazilyApi from '../../../api/src/api/index';

let apiClient: InstanceType<typeof Zodios<typeof lazilyApi>>;
let currentApiKey: string | null = null;

export const createApiClient = (baseURL: string, apiKey?: string) => {
  // lazilyApi should be the makeApi(...) array
  apiClient = new Zodios(baseURL, lazilyApi);
  currentApiKey = apiKey || null;

  // Ensure Authorization header is attached to every request
  const axiosInstance = (apiClient as any).axios || (apiClient as unknown as { axios: any }).axios;
  if (axiosInstance && !axiosInstance.__lazilyAuthInterceptorInstalled) {
    axiosInstance.interceptors.request.use((config: any) => {
      const headers = currentApiKey ? { Authorization: currentApiKey } : {};
      config.headers = { ...(config.headers || {}), ...headers };
      return config;
    });
    axiosInstance.__lazilyAuthInterceptorInstalled = true;
  }
  return apiClient;
};

export const getApiClient = () => {
  if (!apiClient) {
    throw new Error('API client not initialized. Call createApiClient first.');
  }
  return apiClient;
};

export const updateApiKey = (apiKey: string) => {
  currentApiKey = apiKey;
};

export const clearApiKey = () => {
  currentApiKey = null;
};

// Helper function to get headers for requests
export const getRequestHeaders = () => {
  const headers = currentApiKey ? { Authorization: currentApiKey } : {};
  console.log('getRequestHeaders Debug:', {
    currentApiKey: currentApiKey ? 'SET' : 'NOT SET',
    headers
  });
  return headers;
};
